// import libs
import classNames from 'classnames';
import Button from 'common/ui/markup/Button';
import UserModel from 'modules/users/models/UserModel';
import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { t } from 'translations';

// import components

type UserMenuProps = {
    user?: UserModel;
    onLogout: () => void;
    onUndisguise: () => void;
};

const UserMenu: FC<UserMenuProps> = ({ user, onLogout, onUndisguise }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [rendered, setRendered] = useState<boolean>(false);

    const toggleMenu = () => {
        setOpen((s) => !s);
        setRendered(true);
    };

    const close = () => {
        setOpen(false);
    };

    if (!user) {
        return null;
    }

    const avatarUrl = user.getAvatar('small');

    const menuCls = classNames(
        'dropdown-menu dropdown-menu-right profile-notification animated',
        { bounceIn: open },
        { bounceOut: !open }
    );
    const btnClass = classNames('dropdown drp-user', { show: open });
    const isDisguised = localStorage.getItem('original_tokens') !== null;
    return (
        <li>
            <div className={btnClass}>
                <a className="dropdown-toggle cr-pointer" onClick={toggleMenu}>
                    <i className="icon feather icon-settings" />
                </a>
                {rendered && (
                    <div className={menuCls} style={{ right: 0 }}>
                        <div className="pro-head">
                            <img src={avatarUrl} className="img-radius" alt="User-Profile-Image" />
                            <span>{user.getShortName()}</span>
                            <a
                                className="dud-logout cr-pointer"
                                title={t('actions.logout')}
                                onClick={onLogout}
                            >
                                <i className="feather icon-log-out" />
                            </a>
                        </div>
                        <ul className="pro-body">
                            <li>
                                <Link to="/profile" className="dropdown-item" onClick={close}>
                                    <i className="feather icon-user" /> {t('common.profile')}
                                </Link>
                            </li>
                            {isDisguised && (
                                <li style={{ textAlign: 'center' }}>
                                    <Button xs success onClick={onUndisguise}>
                                        {t('users.undisguise')}
                                    </Button>
                                </li>
                            )}
                        </ul>
                    </div>
                )}
            </div>
        </li>
    );
};

export default UserMenu;
